import {getMethod, putMethod} from '~/api'

async function get(hotelId) {
    return await getMethod(`/api/hotelDescription/${hotelId}/location`)
}

async function put(hotelId, request) {
    return await putMethod(`/api/hotelDescription/${hotelId}/location`, request)
}

export {get, put}
